// LGBT-rights / friendliness snapshot for the Higher-or-Lower-style game.
// Figures are approximate public-index snapshots, not stereotypes or "who's actually gay."
//
// Rainbow Index: ILGA-Europe Rainbow Map 2026 (Europe only, 0–100 legal/policy score).
// Equality Index / Legal Index: Equaldex, mid-2026 snapshot (global, 0–100).
// LGBT+ %: Ipsos LGBT+ Pride 2024 self-identification among surveyed countries (approx.).
// Marriage year: first nationwide same-sex marriage (Equaldex / legislative records).
// Est. LGBT+ population: country population (UN/World Bank 2024, from countries.js) × Ipsos %.

import countries, { formatPopulation } from './countries';

const popByCode = Object.fromEntries(
  countries.map((country) => [country.code, country.population])
);

export const GAY_FRIENDLY_COUNTRIES = [
  { name: 'Spain', code: 'es', rainbow: 89, equality: 83, legal: 100, marriageYear: 2005, lgbtPercent: 11 },
  { name: 'Malta', code: 'mt', rainbow: 88, equality: 80, legal: 100, marriageYear: 2017 },
  { name: 'Iceland', code: 'is', rainbow: 86, equality: 93, legal: 96, marriageYear: 2010 },
  { name: 'Belgium', code: 'be', rainbow: 85, equality: 78, legal: 95, marriageYear: 2003, lgbtPercent: 11 },
  { name: 'Denmark', code: 'dk', rainbow: 85, equality: 82, legal: 94, marriageYear: 2012 },
  { name: 'Finland', code: 'fi', rainbow: 70, equality: 76, legal: 87, marriageYear: 2017 },
  { name: 'Germany', code: 'de', rainbow: 70, equality: 80, legal: 99, marriageYear: 2017, lgbtPercent: 12 },
  { name: 'Norway', code: 'no', rainbow: 69, equality: 89, legal: 90, marriageYear: 2009 },
  { name: 'Sweden', code: 'se', rainbow: 68, equality: 75, legal: 85, marriageYear: 2009, lgbtPercent: 11 },
  { name: 'Luxembourg', code: 'lu', rainbow: 68, equality: 67, legal: 82, marriageYear: 2015 },
  { name: 'Greece', code: 'gr', rainbow: 68, equality: 66, legal: 91, marriageYear: 2024 },
  { name: 'Portugal', code: 'pt', rainbow: 67, equality: 77, legal: 94, marriageYear: 2010 },
  { name: 'Netherlands', code: 'nl', rainbow: 64, equality: 77, legal: 90, marriageYear: 2001, lgbtPercent: 17 },
  { name: 'Ireland', code: 'ie', rainbow: 61, equality: 70, legal: 81, marriageYear: 2015 },
  { name: 'France', code: 'fr', rainbow: 60, equality: 74, legal: 90, marriageYear: 2013, lgbtPercent: 10 },
  { name: 'Austria', code: 'at', rainbow: 55, equality: 74, legal: 88, marriageYear: 2019 },
  { name: 'Slovenia', code: 'si', rainbow: 54, equality: 64, legal: 80, marriageYear: 2022 },
  { name: 'Montenegro', code: 'me', rainbow: 53, equality: 56, legal: 76 },
  { name: 'Croatia', code: 'hr', rainbow: 51, equality: 57, legal: 81 },
  { name: 'Switzerland', code: 'ch', rainbow: 50, equality: 70, legal: 76, marriageYear: 2022 },
  { name: 'Estonia', code: 'ee', rainbow: 46, equality: 58, legal: 72, marriageYear: 2024 },
  { name: 'United Kingdom', code: 'gb', rainbow: 44, equality: 67, legal: 79, marriageYear: 2014, lgbtPercent: 13 },
  { name: 'Czechia', code: 'cz', rainbow: 42, equality: 72, legal: 81 },
  { name: 'Albania', code: 'al', rainbow: 41, equality: 48, legal: 68 },
  { name: 'Moldova', code: 'md', rainbow: 38, equality: 37, legal: 66 },
  { name: 'Serbia', code: 'rs', rainbow: 34, equality: 51, legal: 68 },
  { name: 'Cyprus', code: 'cy', rainbow: 34, equality: 51, legal: 66 },
  { name: 'Latvia', code: 'lv', rainbow: 30, equality: 46, legal: 57 },
  { name: 'Slovakia', code: 'sk', rainbow: 25, equality: 46, legal: 58 },
  { name: 'Italy', code: 'it', rainbow: 24, equality: 66, legal: 74 },
  { name: 'Lithuania', code: 'lt', rainbow: 24, equality: 47, legal: 67 },
  { name: 'Hungary', code: 'hu', rainbow: 23, equality: 49, legal: 58 },
  { name: 'Poland', code: 'pl', rainbow: 22, equality: 51, legal: 59, lgbtPercent: 10 },
  { name: 'Bulgaria', code: 'bg', rainbow: 20, equality: 44, legal: 62 },
  { name: 'Ukraine', code: 'ua', rainbow: 19, equality: 49, legal: 59 },
  { name: 'Romania', code: 'ro', rainbow: 19, equality: 46, legal: 60 },
  { name: 'Georgia', code: 'ge', rainbow: 12, equality: 31, legal: 50 },
  { name: 'Armenia', code: 'am', rainbow: 9, equality: 26, legal: 46 },
  { name: 'Belarus', code: 'by', rainbow: 7, equality: 26, legal: 35 },
  { name: 'Turkey', code: 'tr', rainbow: 5, equality: 33, legal: 34 },
  { name: 'Russia', code: 'ru', rainbow: 2, equality: 27, legal: 35 },
  { name: 'Uruguay', code: 'uy', equality: 87, legal: 100, marriageYear: 2013 },
  { name: 'Chile', code: 'cl', equality: 80, legal: 100, marriageYear: 2022, lgbtPercent: 12 },
  { name: 'New Zealand', code: 'nz', equality: 78, legal: 91, marriageYear: 2013 },
  { name: 'Australia', code: 'au', equality: 78, legal: 95, marriageYear: 2017, lgbtPercent: 12 },
  { name: 'Canada', code: 'ca', equality: 78, legal: 95, marriageYear: 2005, lgbtPercent: 12 },
  { name: 'Cuba', code: 'cu', equality: 76, legal: 86, marriageYear: 2022 },
  { name: 'Argentina', code: 'ar', equality: 75, legal: 89, marriageYear: 2010, lgbtPercent: 10 },
  { name: 'Brazil', code: 'br', equality: 75, legal: 94, marriageYear: 2013, lgbtPercent: 14 },
  { name: 'Mexico', code: 'mx', equality: 71, legal: 86, marriageYear: 2022 },
  { name: 'Colombia', code: 'co', equality: 71, legal: 92, marriageYear: 2016, lgbtPercent: 10 },
  { name: 'Nepal', code: 'np', equality: 71, legal: 74 },
  { name: 'Costa Rica', code: 'cr', equality: 69, legal: 85, marriageYear: 2020 },
  { name: 'South Africa', code: 'za', equality: 67, legal: 77, marriageYear: 2006 },
  { name: 'United States', code: 'us', equality: 66, legal: 75, marriageYear: 2015, lgbtPercent: 12 },
  { name: 'Thailand', code: 'th', equality: 65, legal: 63, marriageYear: 2025, lgbtPercent: 15 },
  { name: 'Ecuador', code: 'ec', equality: 64, legal: 86, marriageYear: 2019 },
  { name: 'Israel', code: 'il', equality: 62, legal: 74 },
  { name: 'Taiwan', code: 'tw', equality: 60, legal: 69, marriageYear: 2019 },
  { name: 'China', code: 'cn', equality: 56, legal: 47 },
  { name: 'Philippines', code: 'ph', equality: 54, legal: 49 },
  { name: 'Japan', code: 'jp', equality: 53, legal: 57 },
  { name: 'Peru', code: 'pe', equality: 53, legal: 62 },
  { name: 'India', code: 'in', equality: 52, legal: 50 },
  { name: 'Vietnam', code: 'vn', equality: 52, legal: 51 },
  { name: 'South Korea', code: 'kr', equality: 46, legal: 53 },
  { name: 'Singapore', code: 'sg', equality: 44, legal: 40 },
  { name: 'Pakistan', code: 'pk', equality: 34, legal: 36 },
  { name: 'Kenya', code: 'ke', equality: 23, legal: 26 },
  { name: 'Malaysia', code: 'my', equality: 18, legal: 8 },
  { name: 'Indonesia', code: 'id', equality: 12, legal: 12 },
  { name: 'Nigeria', code: 'ng', equality: 11, legal: 7 },
  { name: 'Uganda', code: 'ug', equality: 10, legal: 3 },
  { name: 'Egypt', code: 'eg', equality: 10, legal: 4 },
  { name: 'Saudi Arabia', code: 'sa', equality: 13, legal: 5 },
  { name: 'Iran', code: 'ir', equality: 6, legal: 9 },
  { name: 'Afghanistan', code: 'af', equality: 1, legal: 0 },
];

export const METRIC_LABELS = {
  rainbow: 'Rainbow Index',
  equality: 'Equality Index',
  legal: 'Legal protection score',
  lgbtPercent: 'Est. LGBT+ identification',
  lgbtPopulation: 'Est. LGBT+ population',
  marriageYear: 'Marriage equality since',
};

export const METRIC_PROMPT_WORDS = {
  rainbow: 'Rainbow Index',
  equality: 'Equality Index',
  legal: 'legal protection score',
  lgbtPercent: 'LGBT+ identification %',
  lgbtPopulation: 'estimated LGBT+ population',
  marriageYear: 'marriage-equality year',
};

export const toNumericValue = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (value == null) return NaN;
  const parsed = Number(String(value).replace(/,/g, '').trim());
  return Number.isFinite(parsed) ? parsed : NaN;
};

export const getMetricLabel = (entry) => METRIC_LABELS[entry?.metric] || 'Score';

export const getMetricPromptWord = (entry) => METRIC_PROMPT_WORDS[entry?.metric] || 'number';

export const getEntryValue = (entry) => toNumericValue(entry?.value);

export const getEntryKey = (entry) => entry.key;

export const formatEntryValue = (entry, value) => {
  const n = toNumericValue(value);
  if (!Number.isFinite(n)) return '—';
  if (entry.metric === 'lgbtPercent') return `${Math.round(n * 10) / 10}%`;
  if (entry.metric === 'lgbtPopulation') return formatPopulation(Math.round(n));
  if (entry.metric === 'marriageYear') return String(Math.round(n));
  return String(Math.round(n));
};

const pushMetric = (entries, country, metric, value) => {
  const n = toNumericValue(value);
  if (!Number.isFinite(n)) return;
  entries.push({
    key: `${country.code}-${metric}`,
    sourceKind: 'country',
    metric,
    name: country.name,
    code: country.code,
    value: n,
  });
};

export const buildComparisonPool = (source = GAY_FRIENDLY_COUNTRIES) => {
  const entries = [];

  source.forEach((country) => {
    pushMetric(entries, country, 'equality', country.equality);
    pushMetric(entries, country, 'legal', country.legal);
    pushMetric(entries, country, 'rainbow', country.rainbow);
    pushMetric(entries, country, 'marriageYear', country.marriageYear);
    pushMetric(entries, country, 'lgbtPercent', country.lgbtPercent);

    const percent = toNumericValue(country.lgbtPercent);
    const population = toNumericValue(popByCode[country.code]);
    if (Number.isFinite(percent) && Number.isFinite(population) && population > 0) {
      pushMetric(entries, country, 'lgbtPopulation', Math.round(population * (percent / 100)));
    }
  });

  return entries;
};

export const pickFromPool = (pool, excludeKeys = []) => {
  const exclude = new Set(excludeKeys);
  const available = pool.filter((entry) => !exclude.has(entry.key));
  const source = available.length ? available : pool;
  return source[Math.floor(Math.random() * source.length)];
};

const pickDifferentValue = (pool, excludeKeys, currentValue) => {
  const exclude = new Set(excludeKeys);
  const different = pool.filter(
    (entry) => !exclude.has(entry.key) && getEntryValue(entry) !== currentValue
  );
  if (different.length) return different[Math.floor(Math.random() * different.length)];
  return pickFromPool(pool, excludeKeys);
};

export const pickComparisonPair = (pool) => {
  const left = pickFromPool(pool);
  const leftValue = getEntryValue(left);
  const oppositeMetric = pool.filter(
    (entry) =>
      entry.metric !== left.metric &&
      entry.key !== left.key &&
      getEntryValue(entry) !== leftValue
  );
  const useMixed = oppositeMetric.length > 0 && Math.random() < 0.55;
  let right = useMixed
    ? oppositeMetric[Math.floor(Math.random() * oppositeMetric.length)]
    : pickDifferentValue(pool, [left.key], leftValue);
  let guard = 0;
  while (getEntryValue(right) === leftValue && guard < 20) {
    right = pickFromPool(pool, [left.key, right.key]);
    guard += 1;
  }
  return { left, right };
};

export const pickNextComparison = (pool, current, extraExclude = []) => {
  const exclude = [current.key, ...extraExclude];
  const currentValue = getEntryValue(current);
  const oppositeMetric = pool.filter(
    (entry) =>
      entry.metric !== current.metric &&
      !exclude.includes(entry.key) &&
      getEntryValue(entry) !== currentValue
  );
  const useMixed = oppositeMetric.length > 0 && Math.random() < 0.55;
  let next = useMixed
    ? oppositeMetric[Math.floor(Math.random() * oppositeMetric.length)]
    : pickDifferentValue(pool, exclude, currentValue);
  let guard = 0;
  while (getEntryValue(next) === currentValue && guard < 20) {
    next = pickFromPool(pool, [...exclude, next.key]);
    guard += 1;
  }
  return next;
};

export const isHigherCorrect = (pickedValue, otherValue, prompt) => {
  if (prompt === 'less') return pickedValue < otherValue;
  return pickedValue > otherValue;
};
